export const manageBulkProcessSiteCoreKeys = {
  manageBulkProcessKey: "ProgramsAndCandidates.ManageBulkProcess",
  bulkProcessListKey:
    "ProgramsAndParticipant.ManageBulkProcess.BulkProcessList",
  headerComponentKey:
    "ProgramsAndParticipant.ManageBulkProcess.HeaderComponent",
  progressStateComponent:
    "ProgramsAndParticipant.ManageBulkProcess.ProgressStateComponent",
};

export const listComponentSiteCoreKeys = {
  cancelBulkProcessConfirmationMessage:
    "ManageBulkProcess.BulkProcessList.CancelBulkProcessConfirmationMessage",
  cancelBulkProcessOption:
    "ManageBulkProcess.BulkProcessList.CancelBulkProcessOption",
  downloadCompletedFileOption:
    "ManageBulkProcess.BulkProcessList.DownloadCompletedFileOption",
  downloadUploadedFileOption:
    "ManageBulkProcess.BulkProcessList.DownloadUploadedFileOption",
};

export const headerComponentSiteCoreKeys = {
  category: "ManageBulkProcess.HeaderComponent.Category",
  bulkProcessCategoryList:
    "ManageBulkProcess.HeaderComponent.BulkProcessCategoryList",
  allBulkProcesses: "BulkProcessCategory.AllBulkProcesses",
  bulkCreateProcess: "BulkProcessCategory.BulkCreateProcess",
  bulkEditProcess: "BulkProcessCategory.BulkEditProcess",
};

export const progressStateComponentSiteCoreKeys = {
  cancelledState: "ManageBulkProcess.ProgressStateComponent.CancelledState",
  completedState: "ManageBulkProcess.ProgressStateComponent.CompletedState",
  inProgressState: "ManageBulkProcess.ProgressStateComponent.InProgressState",
  inQueueState: "ManageBulkProcess.ProgressStateComponent.InQueueState",
  noItemsCancelledMessage: "ManageBulkProcess.ProgressStateComponent.NoItemsCancelledMessage",
  noItemsCompletedMessage: "ManageBulkProcess.ProgressStateComponent.NoItemsCompletedMessage",
  NoItemsInProgressMessage: "ManageBulkProcess.ProgressStateComponent.NoItemsInProgressMessage",
  noItemsInQueueMessage: "ManageBulkProcess.ProgressStateComponent.NoItemsInQueueMessage"
};
